import { h, Component, Fragment } from "preact";
import PFeed from "../../../services/prematch-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../desktop-templates/prematch-single-event.jsx";
import * as W from "../desktop-templates/prematch-events-widget.jsx";

// import {ExtendedOddButton} from "./prematch-odds-table";
import AwrabetWidgetEventsCarousel, {
	WidgetEventsCarouselContent as AwrabetWidgetEventsCarouselContent,
	EventWidgetSlide as AwrabetEventWidgetSlide,
	EventWidgetSlideXL as AwrabetEventWidgetSlideXL
} from '../../awrabet/desktop-components/prematch-events-widget.jsx';

export default class WidgetEventsCarousel extends AwrabetWidgetEventsCarousel {
	render() {
		return (
			<div class="pt-2">
				<WidgetEventsCarouselContent />
			</div>
		);
	}
}

export class WidgetEventsCarouselContent extends AwrabetWidgetEventsCarouselContent {

	render() {
		if (!this.state.events) return null;

		return (
			<W.SliderStyled>
				<W.ScrollContent>
					{Object.values(this.state.events)
						.filter((event) => event.date * 1e3 > Date.now())
						.map((event) => (
							<EventWidgetSlide event={event} />
						))}
				</W.ScrollContent>
			</W.SliderStyled>
		);
	}
}

export class EventWidgetSlide extends AwrabetEventWidgetSlide {

	render({ event }) {
		if (!PFeed.NStorage.get(event.category)) return null;

		const eventMarkets = Object.values(event.sub || {});
		if (!eventMarkets.length || !Object.values(eventMarkets[0].sub || {}).length) return null;

		return <div class="rounded-lg overflow-hidden font-bold w-80 shrink-0 text-sm bg-harif-800 text-slate-100 relative">
			<div class="absolute right-3 top-1 text-center">
				<div class="relative w-20 bg-custom-orange text-slate-950 text-center py-0.5 text-xs -right-1/2 rotate-45">TOP</div>
			</div>
			<div class="fn-wg-top-row flex gap-2 px-2 pb-1 pt-1 text-sm">
				<div class="fn-tournament min-w-0 text-custom-orange truncate">{PFeed.NStorage.get(event.category).name} - {event.tournament_name}</div>
				<div class="fn-date">{this.formatEventTime(event)}</div>
			</div>
			<div class="fn-wg-match-name flex gap-1 items-center px-2 pb-0.5 text-base">
				<div class="min-w-0 flex gap-1 shrink w-1/2  justify-start items-center">
					<W.TeamIconXs src={this.formatHomeTeamIconUrl(event)} />
					<div class="truncate overflow-hidden min-w-0">{event.home}</div>
				</div>
				<div class="w-12 flex-0 text-center text-custom-orange">VS</div>
				<div class="min-w-0 flex gap-1 shrink w-1/2 justify-end items-center">
					<div class="truncate overflow-hidden min-w-0">{event.away}</div>
					<W.TeamIconXs src={this.formatAwayTeamIconUrl(event)} />
				</div>
			</div>
			<div class="px-2">
				<W.OddsContainer>
					{eventMarkets
						.slice(0, 1)
						.flatMap((market) => Object.values(market.sub).map((outcome) => [market, outcome]))
						.map(([market, outcome]) => (
							<ExtendedOddButton market={market} outcome={outcome} />
						))}
				</W.OddsContainer>
			</div>
		</div>
	}
}

export class EventWidgetSlideXL extends AwrabetEventWidgetSlideXL {

	render({ event }) {
		if (!PFeed.NStorage.get(event.category)) return null;

		const eventMarkets = Object.values(event.sub || {});
		if (!eventMarkets.length || !Object.values(eventMarkets[0].sub || {}).length) return null;

		return (
			<W.WidgetCard>
				<W.WidgetCardTop>
					<W.TournamentName>
						{PFeed.NStorage.get(event.category).name} - {event.tournament_name}
					</W.TournamentName>
					<W.TeamIcons>
						<W.TeamIconContainer>
							<W.TeamIcon src={this.formatHomeTeamIconUrl(event)} />
						</W.TeamIconContainer>
						<W.TeamIconContainer>
							<W.TeamIcon src={this.formatAwayTeamIconUrl(event)} />
						</W.TeamIconContainer>
					</W.TeamIcons>
					<W.StartDate>{this.formatEventDate(event)}</W.StartDate>
				</W.WidgetCardTop>
				<W.WidgetCardBottom>
					<W.MatchName>
						<W.TeamName>{event.home}</W.TeamName>
						<W.Versus />
						<W.TeamName>{event.away}</W.TeamName>
					</W.MatchName>
					<W.OddsContainer>
						{eventMarkets
							.slice(0, 1)
							.flatMap((market) => Object.values(market.sub).map((outcome) => [market, outcome]))
							.map(([market, outcome]) => (
								<ExtendedOddButton market={market} outcome={outcome} />
							))}
					</W.OddsContainer>
				</W.WidgetCardBottom>
			</W.WidgetCard>
		);
	}
}

export function ExtendedOddButton({ market, outcome }) {
	return (
		<P.OutcomeButton
			selected={Ticket.hasPrematchOdds(outcome.id)}
			onClick={() => Ticket.togglePrematchOdds(outcome.id)}
		>
			<P.OutcomeName>{outcome.name}</P.OutcomeName>
			<P.OutcomeValue selected={Ticket.hasPrematchOdds(outcome.id)} value={outcome.value} />
		</P.OutcomeButton>
	);
}
